// import axios from "axios";

// const axiosInstance = axios.create({
//   baseURL: "http://127.0.0.1:8000",
//   withCredentials: true,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// axiosInstance.interceptors.request.use((config) => {
//   const token =
//     localStorage.getItem("access_token") ||
//     localStorage.getItem("token");

//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }

//   return config;
// });

// export default axiosInstance;






import axios from 'axios';

const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  'http://localhost:8000';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  },
});

const AUTH_KEYS = [
  'access_token',
  'refresh_token',
  'token',
  'user',
  'just_logged_in',
  'has_plan',
  'user_timezone',
];
const LOGIN_PATH = '/signup';
let hasLoggedOutOnUnauthorized = false;

const clearAuthStorage = () => {
  AUTH_KEYS.forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
};

axiosInstance.interceptors.request.use(
  (config) => {
    const url = config.url || '';
    const isPublicAuthEndpoint =
      url.includes('/api/forgot_password') ||
      url.includes('/api/reset_password') ||
      url.includes('/api/login/') ||
      url.includes('/api/signup/');

    if (!isPublicAuthEndpoint) {
      const token =
        sessionStorage.getItem('access_token') ||
        localStorage.getItem('access_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } else {
      // Ensure public auth endpoints do not receive stale Authorization headers.
      delete config.headers.Authorization;
    }

    // Prevent browser from caching API responses so user data (launches, hubs, etc.)
    // is always fresh without requiring a hard refresh or clearing site data.
    config.headers['Cache-Control'] = 'no-store';
    config.headers['Pragma'] = 'no-cache';

    // Allow multipart/form-data requests (FormData) to work properly.
    // Axios will automatically set the correct Content-Type boundary.
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401 && !hasLoggedOutOnUnauthorized) {
      hasLoggedOutOnUnauthorized = true;
      clearAuthStorage();

      if (typeof window !== 'undefined') {
        const currentPath = window.location.pathname;
        if (currentPath !== LOGIN_PATH) {
          window.location.replace(LOGIN_PATH);
        }
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;